import { Text, spacing } from '@retailer-platform/shared-components'
import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { type GetCollectionQuery } from 'domains/collections/api'
import {
  collectionsViewRuleIsProductsList,
  CollectionsViewRuleProductsList,
} from 'domains/collections/components/collections-view/components/CollectionsViewRuleProductsList'
import {
  collectionsViewRuleIsSearchTerm,
  CollectionsViewRuleSearchTerm,
} from 'domains/collections/components/collections-view/components/CollectionsViewRuleSearchTerm'
import {
  collectionsViewRuleIsProductCategory,
  CollectionsViewRuleProductCategory,
} from 'domains/collections/components/collections-view/components/CollectionsViewRuleProductCategory'

interface Props {
  subject: GetCollectionQuery['collection']['subjects'][0]
}

const RuleWrapper = styled.div({
  paddingTop: spacing.X28,
})

type IsRuleType = (rule: GetCollectionQuery['collection']['subjects'][0]) => boolean

type RuleMapping = [
  IsRuleType,
  FunctionComponent<{ subject: GetCollectionQuery['collection']['subjects'][0] }>
]

const rulesMapping: Array<RuleMapping> = [
  [collectionsViewRuleIsProductsList, CollectionsViewRuleProductsList],
  [collectionsViewRuleIsSearchTerm, CollectionsViewRuleSearchTerm],
  [collectionsViewRuleIsProductCategory, CollectionsViewRuleProductCategory],
]

const getRuleType = (rule: GetCollectionQuery['collection']['subjects'][0]) => {
  const selectedRuleMap = rulesMapping.find(([isRuleType, _]) => isRuleType(rule))

  if (selectedRuleMap) {
    return selectedRuleMap[1]
  }
}

export const CollectionsViewRule: FunctionComponent<Props> = ({ subject }) => {
  const RuleComponent = getRuleType(subject)

  return (
    <RuleWrapper>
      <Text size="medium" weight="semibold">
        {subject.subjectName}
      </Text>
      {RuleComponent && <RuleComponent subject={subject} />}
    </RuleWrapper>
  )
}
